import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { ActivityType } from '../models/ActivityType'
import { ActivityTypeForm } from '../forms/ActivityTypeForm'
import { ActivityTypeFilter } from '../filters/ActivityTypeFilter'
import { ActivityTypeService } from '../services/ActivityTypeService'

export const useActivityTypeStore: KsStoreHook<ActivityType, ActivityTypeForm, ActivityTypeFilter> = createKsStore({
  id: 'activityTypes',
  modelClass: ActivityType,
  formClass: ActivityTypeForm,
  filterClass: ActivityTypeFilter,
  service: ActivityTypeService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Type d'activité #${item.id}`,
  signalREventName: 'ActivityTypeModel',
  isReferential: true
})
